import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter, push } from 'react-router-redux';
import store, { history } from './store';
import App from './containers/app';
import './index.css';
import axios from 'axios';
import { CHECK_LOGIN_DONE } from './reducer/user';

if (!Array.prototype.find) {
    Array.prototype.find = function (predicate) {
        if (this === null) {
            throw new TypeError('Array.prototype.find called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return value;
            }
        }
        return undefined;
    };
}

axios.defaults.validateStatus = (status) => {
    if (status === 403) {
        store.dispatch({
            type: CHECK_LOGIN_DONE,
            state: { isLogin: false }
        });
        store.dispatch(push('/login'));
        return true;
    } else if (status !== 200) {
        store.dispatch(push('/error'));
        return true;
    } else {
        return true;
    }
}
const target = document.querySelector('#root')

render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <div>
                <App />
            </div>
        </ConnectedRouter>
    </Provider>,
    target
)


// WEBPACK FOOTER //
// ./src/index.js